import moment from 'moment';

export const plugins = [
  {
    id: 'mouseLine',

    afterEvent: function (chart, e) {
      var chartArea = chart.chartArea;
      if (
        e.x >= chartArea.left &&
        e.y >= chartArea.top &&
        e.x <= chartArea.right &&
        e.y <= chartArea.bottom &&
        chart.active.length
      ) {
        chart.options.mouseLine.x = chart.active[0]._model.x;
      } else {
        chart.options.mouseLine.x = NaN;
      }
    },
    beforeDraw: function (c) { },

    afterDraw: function (chart, easing) {
      var ctx = chart.chart.ctx;
      var chartArea = chart.chartArea;
      var x = chart.options.mouseLine.x;

      if (!isNaN(x)) {
        ctx.save();
        ctx.strokeStyle = chart.options.mouseLine.color;
        ctx.lineWidth = 1;
        ctx.moveTo(chart.options.mouseLine.x, chartArea.bottom);
        ctx.lineTo(chart.options.mouseLine.x, chartArea.top);
        ctx.stroke();
        ctx.restore();
      }
    },
  },
];

export const dataFunc = (labels, close, strike, RR) => {
  return {
    labels,
    datasets: [
      {
        type: 'line',
        borderColor: '#71B37C',
        pointBorderColor: '#71B37C',
        pointBackgroundColor: '#71B37C',
        pointHoverBackgroundColor: '#71B37C',
        pointHoverBorderColor: '#71B37C',
        spanGaps: true,
        lineTension: 0,
        label: 'Stock Price',
        data: close,
        backgroundColor: '#2d3734',
      },

      {
        type: 'line',
        borderColor: '#f9f1f1',
        pointBorderColor: '#f9f1f1',
        pointBackgroundColor: '#f9f1f1',
        pointHoverBackgroundColor: '#f9f1f1',
        pointHoverBorderColor: '#f9f1f1',
        spanGaps: true,
        lineTension: 0,
        label: 'Strike Price',
        data: strike,
      },
      {
        type: 'line',
        borderColor: '#fbf3a8',
        pointBorderColor: '#fbf3a8',
        pointBackgroundColor: '#fbf3a8',
        pointHoverBackgroundColor: '#fbf3a8',
        pointHoverBorderColor: '#fbf3a8',
        spanGaps: true,
        lineTension: 0,
        label: 'RR$',
        data: RR,
      },
    ],
  };
};

export const chartOptionsFun = (modalRowData, customRadius, ticker) => {
  return {
    scales: {
      xAxes: [
        {
          display: true,
          font: {
            size: 8,
          },
          ticks: {
            fontColor: '#f9f1f1',
          },
        },
      ],
      yAxes: [
        {
          display: true,
          position: 'left',

          font: {
            size: 8,
          },
          ticks: {
            fontColor: '#f9f1f1',
          },
          labels: {
            labelMaxWidth: '10px',
            show: true,
          },
        },
      ],
    },

    responsive: true,
    title: {
      display: true,
      text: `Stock Price & RR$ for ${ticker} ${moment(
        modalRowData.expiration
      ).format('MMMM DD')} $${modalRowData.strike} ${modalRowData.put_call}`,
      fontSize: 16,
      fontColor: 'white',
    },
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 5,
        usePointStyle: true,
        fontColor: 'white',
      },
    },
    tooltips: {
      enabled: true,
      intersect: false,
      mode: 'index',

      backgroundColor: 'darkblue',
    },
    hover: {
      mode: 'index',
      intersect: false,
    },

    mouseLine: {
      color: 'grey',
    },
    responsiveAnimationDuration: 500,

    elements: {
      point: {
        radius: customRadius,
        display: true,
      },
    },
    layout: {
      padding: {
        left: 5,
        right: 5,
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/components/Modals/RRDollarModal/constant.js